export function setYearSynchronized(YearSynchronized:any)
{
    return({
        type:"SET_YEAR_SYNCHRONIZED",
        YearSynchronized
    })
}